export default __webpack_public_path__ + "static/Splenda-fe9b302611184d100c3f96ad036a0be0.png";